<template>
            <el-menu-item :index="item.href" v-if="!hasChild(item) "
                          :route="item.href"
            >
                <span>{{item.title}}</span>
            </el-menu-item>
            <el-submenu :index="item.title" v-else-if="hasChild(item)" :popper-append-to-body="true" >
                <template slot="title"> {{item.title}}</template>
                <top-menu :item="citem" v-for="citem in item.child" :key="citem.title" ></top-menu>
            </el-submenu>
</template>

<script>
    import util from "@/mixins/util";

    export default {
        name: "TopMenu",
        mixins: [],
        components: {},
        props: {
            item:{
              type:Object,
            },

        },
        data() {
            return {
                ttt : true,
            }
        },
        beforeRouterEnter() {
        },
        created() {
        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {
        },
        methods: {
            hasChild(item){
                return item.child ? (item && item.child ? true : false) : false
            },

        },
        watch: {},

    }
</script>

<style scoped>

</style>